module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "camInfoWrapper"
  }, [_c('div', {
    staticClass: "camInfoTop"
  }, [_c('div', {
    staticClass: "camInfoLeft"
  }, [_c('div', {
    staticClass: "campaignName"
  }, [_vm._v("\n                " + _vm._s(_vm.campaignInfo.campaign_nm) + "\n                "), _c('img', {
    staticClass: "export_excel",
    attrs: {
      "id": "export_excel",
      "title": _vm.excel,
      "src": require("../../../assets/excel-icon.png"),
      "alt": "export_xls"
    },
    on: {
      "click": _vm.exportTable
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "campaignStatus"
  }, [_c('div', {
    staticClass: "statusText",
    class: _vm.camStatus
  }, [_vm._v("\n                    " + _vm._s(_vm.status) + "\n                ")]), _vm._v("\n                " + _vm._s(_vm.periodData) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "camInfoRight"
  }, [_c('div', {
    staticClass: "camInfoCompany"
  }, [_c('span', [_vm._v("광고주 ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.campaignInfo.client_nm))])]), _vm._v(" "), (_vm.cust_knd.a) ? _c('div', {
    staticClass: "camInfoCompany"
  }, [_c('span', [_vm._v("에이전시 ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.campaignInfo.agency_nm))])]) : _vm._e(), _vm._v(" "), (_vm.cust_knd.l) ? _c('div', {
    staticClass: "camInfoCompany"
  }, [_c('span', [_vm._v("렙사 ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.campaignInfo.lab_cust_nm))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "camInfoBottom"
  }, [_c('v-progress-linear', {
    attrs: {
      "title": _vm.progressText,
      "height": 10
    },
    model: {
      value: (_vm.initProgress),
      callback: function($$v) {
        _vm.initProgress = $$v
      },
      expression: "initProgress"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "progressInfo"
  }, [_c('span', [_vm._v(_vm._s(_vm.parseDateFormat(_vm.ymd.fr)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.parseDateFormat(_vm.ymd.to)))])])], 1), _vm._v(" "), _c('ExcelTable', {
    attrs: {
      "campaignType": _vm.campaignType,
      "checkDate": _vm.checkDate
    }
  }), _vm._v(" "), _c('iframe', {
    attrs: {
      "id": "exportIE"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7574dc1c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign/camMain/CamInfo.vue
// module id = 861
// module chunks = 1